const priceWithDecimals = num => (Math.round(num * 100) / 100).toFixed(2);

const priceWithoutDecimals = num => {
  if (num % 1 !== 0) {
    return Number(num).toFixed(2);
  }
  return Number(num);
};

const computeTotalPrice = items => {
  if (!items) return 0;
  let TOTAL = 0.0;

  items.map(item => {
    const total = item.details.reduce((acc, detail) => {
      const optionsTotal = detail.options.reduce((acc1, option) => {
        const price = option.price ? option.price / 100 : 0;
        return acc1 + (parseFloat(price));
      }, 0.0);
      return acc + optionsTotal + (parseFloat(detail.price / 100));
    }, 0.0);
    TOTAL += total;
    return total;
  });
  return TOTAL;
};

export {
  priceWithDecimals,
  priceWithoutDecimals,
  computeTotalPrice
};
